export const CHANGE_SELECT = 'fulcrum/containers/Form/Feature/CHANGE_SELECT'
